import { useEffect, useState } from "react";
import {
  getGasConsumptionData,
  getPowerStationsData,
} from "../../../Rest_api/RestApi";
import { ConsumptionData, PowerStationData } from "../../../models/gas";
import {
  ChartDataParams,
  FormatChartData,
} from "../../../components/recharts/functions";
import { ReMixChart } from "../../../components/recharts/ReMixCharts";
import { ChartType } from "../../../models/chart_model";
import { ExchangeColors } from "../Exchange3/FormatData";
import { renderQuarterTick } from "../../../components/recharts/components";
import FilterMenu from "../../../components/FilterMenu";
import { SearchBox } from "../../../components/Search";
import { FilterTab } from "../../../components/Filters";
import {
  CHART_TYPES,
  GAS_BAR_GAP,
  GAS_COLORS,
  getAvailableMonths,
} from "./Gas_Const";
import { capitalize, titleCase } from "../../../extensions/extension";
import { isMobile } from "../../../common";

const GROUP_BY = [
  {
    key: "month",
    label: "Month",
  },
  {
    label: "Sector",
    key: "sector__name",
  },
  {
    label: "State",
    key: "state__state_name",
  },
  {
    label: "Station",
    key: "power_station_name",
  },
];

const keys = [
  {
    key: "month",
    label: "Month",
  },
  {
    key: "Sector",
    label: "sector__name",
  },
  {
    key: "State",
    label: "state__state_name",
  },
];

const yAxis1 = [
  {
    value: "tentative_generation_during_the_month_mus",
    label: "Tentative Generation",
    color: GAS_COLORS["tentative_generation_during_the_month_mus"], // Light Gray
  },
];

const alloted = [
  {
    value: "rlng_imported_long_term_contratcs",
    label: "RLNG Imported Long Term ",
    color: GAS_COLORS["rlng_imported_long_term_contratcs"], // Light Blue
  },
  {
    value: "domestic_gas_alloted_mmscmd_total",
    label: "Alloted Domestic Gas ",
    color: GAS_COLORS["domestic_gas_alloted_mmscmd_total"], // Light Orange
  },
];

const gasConsumed = [
  {
    value: "gas_consumed_supplied_mmscmd_rlng_imported_long_term",
    label: "Consumed RLNG Imported Long Term ",
    color: GAS_COLORS["gas_consumed_supplied_mmscmd_rlng_imported_long_term"], // Light Red (Pinkish)
  },
  {
    value: "gas_consumed_supplied_mmscmd_rlng_imported_spot",
    label: "Consumed RLNG Imported Spot ",
    color: GAS_COLORS["gas_consumed_supplied_mmscmd_rlng_imported_spot"], // Lighter Green
  },
  {
    value: "gas_consumed_supplied_mmscmd_domestic_total",
    label: "Consumed Domestic Gas ",
    color: GAS_COLORS["gas_consumed_supplied_mmscmd_domestic_total"], // Light Purple
  },
];

const yAxis2 = [
  ...alloted.map((item) => {
    return {
      ...item,
      stackId: "Alloted",
    };
  }),
  ...gasConsumed.map((item) => {
    return {
      ...item,
      stackId: "Consumed",
    };
  }),
];

const yAxis3 = [
  { value: "alternate_fuel_used_kl_naptha", label: "Naptha (KL)" },
  { value: "alternate_fuel_used_kl_hsd", label: "HSD (KL)" },
];

const allotedConsumed = ["Alloted", "Consumed"];

const secondAxis = [
  {
    label: "Gas",
    unit: "Gas (MMSCMD)",
    unit_only: "MMSCMD",
    value: yAxis2,
  },
  {
    label: "Alternate Fuel",
    unit_only: "KL",
    unit: "Alternate Fuel (KL)",
    value: yAxis3,
  },
];

export function PowerStationByDate() {
  const [consumptionData, setConsumptionData] = useState<PowerStationData[]>(
    []
  );
  const [chartData, setChartData] = useState<Record<string, any>[]>([]);
  const [chartKeys, setChartKeys] = useState<any[]>([]);
  const [selectedChartType, setSelectedChartType] = useState(CHART_TYPES[1]);
  const [selectedAllotedConsumed, setSelectedAllConsumed] = useState<string[]>(
    []
  );
  const [selectedGroupKeys, setSelectedGroupKeys] = useState<any[]>([
    GROUP_BY[0],
  ]);
  const [selectedKeys, setSelectedKeys] = useState<any[]>(keys);
  const [selectedPowerStations, setSelectedPowerStation] = useState<any[]>([]);
  const [selectedMonthYear, setSelectedMonthYear] = useState<any[]>([]);
  const [selectedSecondAxis, setSelectedSecondAxis] = useState<{
    label: string;
    unit: string;
    unit_only: string;
    value: any[];
  }>(secondAxis[0]);

  const [selectedSector, setselectedSector] = useState<any[]>([]);
  const [selectedState, setselectedState] = useState<any[]>([]);
  useEffect(() => {
    _handlefetchData();
  }, []);
  useEffect(() => {
    let filteredData = consumptionData;
    if (selectedSector.length > 0) {
      filteredData = filteredData.filter((item) =>
        selectedSector.includes(item.sector__name)
      );
    }
    if (selectedState.length > 0) {
      filteredData = filteredData.filter((item) =>
        selectedState.includes(item.state__state_name)
      );
    }

    if (selectedPowerStations.length > 0) {
      filteredData = filteredData.filter((item) =>
        selectedPowerStations
          .map((item) => item.label)
          .includes(item.power_station_name)
      );
    }

    if (selectedMonthYear.length > 0) {
      filteredData = filteredData.filter((item) =>
        selectedMonthYear.map((item) => item.label).includes(item.month_year)
      );
    }

    const par: ChartDataParams = {
      keys: selectedGroupKeys.map((item) => item.key),
      groupBy: [],
      volumeKey: yAxis1[0].value,
      priceKey: "",
      aggregationKeys: yAxis2
        .map((item) => item.value)
        .concat(yAxis3.map((item) => item.value)),
      data: filteredData,
    };
    const data = FormatChartData(par);
    console.log(data);

    setChartData(data.data);
    setChartKeys(data.keys);
  }, [
    consumptionData,
    selectedGroupKeys,
    selectedKeys,
    selectedSector,
    selectedState,
    selectedPowerStations,
    selectedMonthYear,
  ]);

  function _handleGroupByChange(index: number) {
    setSelectedGroupKeys([GROUP_BY[index]]);
  }

  function _handleSelectedSector(item: string) {
    const isSelected = selectedSector.find((value) => value === item);
    if (isSelected) {
      setselectedSector(selectedSector.filter((value) => value !== item));
    } else {
      setselectedSector((prev) => [...prev, item]);
    }
  }

  function _handleselectedState(item: string) {
    const isSelected = selectedState.find((value) => value === item);
    if (isSelected) {
      setselectedState(selectedState.filter((value) => value !== item));
    } else {
      setselectedState((prev) => [...prev, item]);
    }
  }
  async function _handlefetchData() {
    const newData = await getPowerStationsData({});
    setConsumptionData(
      newData.map((item) => {
        return {
          ...item,
          month: item.month.slice(0, 3),
          month_year: item.month + "-" + item.year,
          state__state_name: titleCase(item.state__state_name),
        };
      })
    );
  }
  return (
    <div className="tabContent">
    <div className="gas-page-container">
      <div className="side-filters-container overflow-scroll  w-60">
        <FilterMenu
          title="X Axis"
          items={GROUP_BY.map((item) => item.label)}
          selectedItems={selectedGroupKeys.map((item) => item.label)}
          onSelect={(item, index) => {
            _handleGroupByChange(index);
          }}
        />

        <FilterMenu
          title="Chart Type"
          items={CHART_TYPES.map((item) => item.label)}
          selectedItems={[selectedChartType.label]}
          onSelect={(item, index) => {
            setSelectedChartType(CHART_TYPES[index]);
          }}
        />

        <FilterMenu
          title="Plot"
          items={allotedConsumed}
          selectedItems={selectedAllotedConsumed}
          setSelectedItems={(items) => {
            setSelectedAllConsumed(items);
          }}
          onSelect={() => {}}
        />

        <FilterMenu
          title="State"
          items={consumptionData
            .map((item) => item.state__state_name)
            .filter((value, index, self) => self.indexOf(value) === index)
            .sort((a, b) => a.localeCompare(b))}
          selectedItems={selectedState.map((item) => item)}
          onSelect={(item, index) => {
            _handleselectedState(item);
          }}
        />
        <FilterMenu
          title="Sector"
          items={consumptionData

            .map((item) => item.sector__name)
            .filter((value, index, self) => self.indexOf(value) === index)}
          selectedItems={selectedSector.map((item) => item)}
          onSelect={(item, index) => {
            _handleSelectedSector(item);
          }}
        />
      </div>
      <div className="gas-chart-container">
        <h2 className="chartHeading mb-4">
          {selectedSecondAxis.label +
            " Consumption" +
            " (" +
            selectedSecondAxis.unit_only +
            ")"}{" "}
          and Tentative Generation(MUs) by {selectedGroupKeys[0].label}
        </h2>

        <div className="stationAnalysis-Filters">
          <div className="w-full">
            <SearchBox
              options={Array.from(
                new Set(
                  consumptionData.map((item) => {
                    return {
                      value: item.power_station_name,
                      label: item.power_station_name,
                    };
                  })
                )
              )
                .filter(
                  // value must be unique
                  (value, index, self) =>
                    self.findIndex((t) => t.value === value.value) === index
                )
                .sort((a, b) => a.label.localeCompare(b.label))}
              isMany={true}
              placeholder="Search Power Station"
              selectedOptions={selectedPowerStations}
              onChange={(selected: any) => {
                setSelectedPowerStation(selected);
              }}
            />
          </div>
          <div style={{ width: isMobile ? "100%" : "500px" }}>
            <SearchBox
              // unique month-year combination
              options={getAvailableMonths(consumptionData)}
              isMany={true}
              placeholder="Apr-2024 to Jul-2024"
              selectedOptions={selectedMonthYear}
              onChange={(selected: any) => {
                setSelectedMonthYear(selected);
              }}
            />
          </div>
          <div className="powerStation-fuelType">
            <FilterTab
              options={secondAxis.map((item) => item.label)}
              selected={[selectedSecondAxis.label]}
              onClick={(item: any, index: any) => {
                setSelectedSecondAxis(secondAxis[index]);
              }}
            />
          </div>
        </div>
        <div className="w-full h-full">
          <ReMixChart
            data={chartData}
            barCategoryGap={GAS_BAR_GAP}
            xAxisTickMargin={15}
            secondYAxisLabel="Generation (MUs)"
            yAxisLabel={selectedSecondAxis.unit}
            secondYAxisWidth={100}
            brushIndex={{
              startIndex: 0,
              endIndex: chartData.length == 0 ? 0 : chartData.length - 1,
            }}
            showBrush={chartData.length > 8}
            legends={[
              ...(
                chartKeys.map((key, index) => {
                  return selectedSecondAxis.value
                    .map((item, index1) => {
                      if (
                        selectedAllotedConsumed.length === 0 ||
                        selectedAllotedConsumed.includes(item.stackId)
                      ) {
                        return {
                          dataKey: key + "_" + item.value,
                          name: item.label + " " + key,
                          type: selectedChartType.value,
                          stroke: item.color,
                          legendColor: item.color,
                          stackId:
                            selectedChartType.stackId !== undefined
                              ? item.stackId
                              : undefined,
                        };
                      } else {
                        return null; // return null or undefined to skip
                      }
                    })
                    .filter((item) => item !== null); // filter out the null values
                }) as any
              ).flat(),

              ...chartKeys
                .map((key, index) => {
                  return {
                    dataKey: key + "_" + yAxis1[0].value,
                    name: yAxis1[0].label + " (MUs)",
                    type: ChartType.Line,
                    stroke:
                      GAS_COLORS["tentative_generation_during_the_month_mus"],
                    legendColor:
                      GAS_COLORS["tentative_generation_during_the_month_mus"],
                    yAxisId: "right",

                    stackId: "1",
                  };
                })
                .flat(),
            ]}
            xDataKey={selectedGroupKeys[0].key}
            rendexSecondXTick={(value: any) => renderQuarterTick(value, 1)}
          />
        </div>
      </div>
    </div>
    </div>
  );
}
